import React, { useState } from 'react'

import { Button, Chip, DialogContent, IconButton } from '@material-ui/core'
import CommentIcon from '@material-ui/icons/FormatQuote'
import { Modal } from 'asterX-UI/Modals'
import ModalTitle from 'asterX-UI/Modals/ModalTitle'
import { CameraPlusIcon } from 'asterX-UI/Icons'
import Lightbox from 'react-18-image-lightbox'

const TechStateInfoModal = ({ open, onClose, data }) => {
  const [photoIndex, setPhotoIndex] = useState(null)
  const handleClose = () => {
    onClose()
  }
  const handleOpenPhotos = () => {
    setPhotoIndex(0)
  }

  return (
    <Modal
      onClose={handleClose}
      aria-labelledby="TechStateInfoModal-title"
      maxWidth={'sm'}
      open={open}
    >
      <ModalTitle id="TechStateInfoModal-title" onClose={handleClose}>
        {data?.name}
      </ModalTitle>
      <DialogContent>
        {data.paintThickness && (
          <div style={{ marginBottom: '15px' }}>
            Толщина ЛКП: <b>{data.paintThickness} мкр.</b>
          </div>
        )}
        <div
          style={{
            marginBottom: '15px',
            display: 'flex',
            flexWrap: 'wrap'
          }}
        >
          {data.state.map((state, index) =>
            state === 'OK' ||
            state === 'Не предусмотрено' ||
            state === 'Заводской окрас детали' ? (
              <Chip
                key={index}
                label={state}
                size="small"
                style={{
                  marginRight: '5px',
                  marginBottom: '5px',
                  backgroundColor: '#00a161',
                  color: '#FFF'
                }}
              />
            ) : (
              <Chip
                key={index}
                label={state}
                size="small"
                style={{
                  marginRight: '5px',
                  marginBottom: '5px',
                  backgroundColor: 'rgba(241,3,32,0.77)',
                  color: '#FFF'
                }}
              />
            )
          )}
        </div>
        {data.comments && (
          <div
            style={{
              maxWidth: '250px',
              fontSize: '16px',
              fontWeight: '400',
              fontStyle: 'italic',
              marginTop: '10px',
              marginLeft: '0px',
              marginBottom: '15px'
            }}
          >
            <CommentIcon style={{ color: '#CCC' }} />
            {data.comments}
          </div>
        )}
        {data.photos?.length > 0 && (
          <div>
            <Button
              variant={'contained'}
              color="primary"
              onClick={handleOpenPhotos}
            >{`Посмотреть ${data.photos?.length} фото`}</Button>
          </div>
        )}
      </DialogContent>
      {photoIndex !== null && data.photos?.length > 0 && (
        <Lightbox
          reactModalStyle={{
            content: { zIndex: 1400 },
            overlay: { zIndex: 1400 }
          }}
          mainSrc={data.photos[photoIndex]}
          nextSrc={data.photos[(photoIndex + 1) % data.photos.length]}
          prevSrc={
            data.photos[
              (photoIndex + data.photos.length - 1) % data.photos.length
            ]
          }
          onCloseRequest={() => setPhotoIndex(null)}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + data.photos.length - 1) % data.photos.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % data.photos.length)
          }
        />
      )}
    </Modal>
  )
}
export default TechStateInfoModal
